























































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import SignaturePad from 'signature_pad';
import {ResizeSensor} from 'css-element-queries';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import BindAttrs from '@/utils/binds-attrs';
import AmetrasSignatureCaptureTemplate from '@/fields/signature/AmetrasSignatureCaptureTemplate.vue';
import AdvancedConfirmDialog from '@/views/AdvancedConfirmDialog.vue';
import {DialogInstance} from '@/utils/dialog.stack';


/**
 * General Component for Fields of type SIGNATURE
 */
@Component({
  components: {AdvancedConfirmDialog, AmetrasSignatureCaptureTemplate, AmetrasTextFieldTemplate},
  mixins: [BindAttrs]
})
export default class AmetrasSignatureFieldTemplate extends Vue implements DialogInstance {

  @Prop() marginDefinition!: string;
  @Prop() paddingDefinition!: string;
  @Prop() value!: string;
  @Prop() label!: string;
  @Prop() readonly!: boolean;
  @Prop() typeSpecificSettings!: DisguiseDto.SignatureFieldSpecificSettings;
  innerValue: string | undefined;
  signaturePad: SignaturePad | undefined;
  canvasEl: HTMLCanvasElement | undefined;
  canvasWrapperEl: HTMLElement | undefined;
  showSignatureDialog: boolean = false;
  textValue: string = '';
  signatureDialog: {
    value: string;
  } | null = null;
  hideOverlay: boolean = false;

  private ASPECT_RATIO = 1 / 3;
  private resizeSensor: ResizeSensor | null = null;

  @Watch('value') valueChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.innerValue = newValue;
      this.textValue = this.innerValue.split('|')[1];
      this.redrawCanvas();
    }
  }

  created() {
    this.innerValue = this.value;
  }

  mounted() {
    if (this.innerValue) {
      this.textValue = this.innerValue.split('|')[1];
    }
    const canvasEl = this.$refs.canvasEl;
    const canvasWrapperEl = this.$refs.canvasWrapperEl;
    if (canvasEl instanceof HTMLCanvasElement && canvasWrapperEl instanceof HTMLElement) {
      this.canvasEl = canvasEl;
      this.canvasWrapperEl = canvasWrapperEl;

      this.signaturePad = new SignaturePad(canvasEl, {});
      this.signaturePad.off();

      this.resizeSensor = new ResizeSensor(canvasWrapperEl, () => {
        this.redrawCanvas();
      });

    } else {
      alert('Invalid Signature pad definition!');
    }
  }

  redrawCanvas() {
    if (this.canvasEl && this.canvasWrapperEl && this.signaturePad) {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const width = this.canvasWrapperEl.offsetWidth || 300;
      this.canvasEl.width = width;
      this.canvasEl.height = width * this.ASPECT_RATIO;
      const twoDimensionalContext = this.canvasEl.getContext('2d');
      if (twoDimensionalContext) {
        twoDimensionalContext.scale(ratio, ratio);
      }
      this.signaturePad.clear();
      if (this.innerValue) {
        const signatureDataURL = this.innerValue.split('|')[0];
        if (signatureDataURL !== '') {
          this.signaturePad.fromDataURL(signatureDataURL);
        }
      }
    } else {
      alert('Signature pad not initialized properly!');
    }
  }

  checkConditionsAndOpenSignaturePad() {
    if (!this.readonly) {
      if (this.typeSpecificSettings && this.typeSpecificSettings.beforeCaptureEvent !== undefined) {
        switch (this.typeSpecificSettings.beforeCaptureEvent.type) {
          case 'CheckFTEventDto': {
            this.$emit('check', () => {
              this.openSignaturePad();
            });
            break;
          }
          default: {
            this.openSignaturePad();
            break;
          }
        }
      } else {
        this.openSignaturePad();
      }
    }
  }

  apply() {
    if (this.signatureDialog && this.signatureDialog.value) {
      this.innerValue = this.signatureDialog.value;
      this.redrawCanvas();

      this.$emit('input', this.signatureDialog.value);
      this.$emit('change', this.signatureDialog.value);

      this.signatureDialog = null;
      this.showSignatureDialog = false;
    } else {
      alert('no signature found');
    }
  }

  abort() {
    this.showSignatureDialog = false;
    this.signatureDialog = null;
  }

  shouldHideOverlay(): void {
    this.hideOverlay = true;
  }

  shouldRestoreHideOverlay(): void {
    this.hideOverlay = false;
  }

  private openSignaturePad() {
    this.signatureDialog = {
      value: ''
    };
    this.showSignatureDialog = true;
  }

}

